import { useRuntimeConfig } from 'virtual:runtime-config';

export const MF_NAME = (import.meta.env?.VITE_RUNTIME_MF_NAME as string) ?? 'help-center-mfe';

if (!MF_NAME || typeof MF_NAME !== 'string') {
  throw new Error('[MF] имя микрофронтенда должно быть задано');
}

export const SENTRY_DSN = useRuntimeConfig()[MF_NAME].VITE_RUNTIME_SENTRY_DSN ?? '';
const VITE_RUNTIME_IS_PROD = useRuntimeConfig()[MF_NAME].VITE_RUNTIME_IS_PROD ?? import.meta.env.VITE_RUNTIME_IS_PROD;

export const IS_PROD = VITE_RUNTIME_IS_PROD ? Boolean(Number(VITE_RUNTIME_IS_PROD)) : false;
